// extracted by mini-css-extract-plugin
export default {"link":"styles_link__JtULu","card":"styles_card__1Z248","button":"styles_button__oella"};